import React from "react";
import Input from "../../../../../widget/common/form/Input";
import { SignupAccountVerificationContextImport } from "../../../../../provider/onboarding/signup/account_verification/SignupAccountVerificationContextProvider";
import { CountryCodeList } from "../../../../../model/country_code/CountryCodeModel";
import PhoneNumber from "../../../../../widget/common/form/PhoneNumber";

export const SignupChangeEmailField = () => {
  const { handleOnChange, changeEmail, validateStatus, changeEmailIsValid } =
    SignupAccountVerificationContextImport();

  return (
    <Input
      type="email"
      name="change_email"
      handleOnChange={handleOnChange}
      value={changeEmail}
      label="email"
      validate={true}
      error={validateStatus ? !changeEmailIsValid : false}
    />
  );
};

export const SignupChangePhoneField = () => {
  const {
    handleOnChange,
    changePhoneIsValid,
    phoneField,
    applyCountryCode,
    validateStatus,
  } = SignupAccountVerificationContextImport();

  const applyCode = (countryCodeDetail: CountryCodeList) => {
    applyCountryCode(countryCodeDetail);
  };

  return (
    <PhoneNumber
      name="phone_number"
      handleOnChange={handleOnChange}
      value={phoneField.phone_number}
      code={phoneField.phone_code}
      label="phone_number"
      callback={applyCode}
      validate={true}
      error={validateStatus ? !changePhoneIsValid : false}
    />
  );
};
